<template>
    <b-card no-header no-footer>
        <ValidationObserver ref="form">
          <form @submit.prevent="onSubmit">
              <b-row>
                <b-col cols="12" md="6">
                  <template v-for="(m, index) in filterModel(['school_name', 'principal', 'npsn', 'treasurer', 'student_total', 'address', 'district_id', 'village_id'])">
                    <div :key="'informasi_sekolah_' + index">
                      <form-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :options="m.type === 'radio' ? getClassicOptions(index) : getOptions(index)" :need-label="true" v-model="m.value" :rules="typeof m.rules !== 'undefined' ? m.rules : null" :disabled="typeof m.disabled !== 'undefined' ? m.disabled : null" :id="index" />
                    </div>
                    
                  </template>
                </b-col>
                <b-col cols="12" md="6">
                  <h5>Informasi Akun</h5>
                  <template v-for="(m, index) in filterModel(['username', 'email', 'password', 'contact'])">
                    <div :key="'tugas_' + index">
                      <form-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :options="m.type === 'radio' ? getClassicOptions(index) : getOptions(index)" :need-label="true" v-model="m.value" :rules="typeof m.rules !== 'undefined' ? m.rules : null" :disabled="typeof m.disabled !== 'undefined' ? m.disabled : null" :id="index" />
                      <small v-if="mode === 'update' && index === 'password'" style="margin-top: -1rem !important; display: block;" class="mb-3">Kosongkan jika tidak ingin mengubah password.</small>
                    </div>
                    
                  </template>
                </b-col>
              </b-row>
              <div>
                <b-button type="submit" variant="primary" class="mt-0"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> Simpan</b-button>
                <b-button :to="'/sekolah'" variant="secondary" class="ml-3 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> Batal</b-button>
              </div>
            </form>
        </ValidationObserver>
      </b-card>
</template>

<script>
import { saveProcess, setModelValue, scrollToError, objectToOptions, classicObjectToOptions } from '@/_helpers'
import formGroupInput from '@/components/FormGroupInput.vue'
import User from '@/models/User.js'
import City from '@/models/City.js'
import District from '@/models/District.js'
import Village from '@/models/Village.js'
import School from '@/models/School.js'

const userModel = new User()
const schoolModel = new School()
const cityModel = new City()
const districtModel = new District()
const villageModel = new Village()
const dapilModel = new Dapil()

export default {
  components: {
    formGroupInput
  },
  watch: {
    '$route.params.id': function (val) {
      if (this.mode === 'update') {
        this.getDetail()
      }
    },
    'userModel.role.value': async function (val) {
      this.setHideModels(val)
    },
    'userModel.city_id.value': async function (val, oldVal) {
      if (val) {
        this.schoolModel.district_id.options = await this.getDistricts(val)
        this.totalPromiseAreaCount++;
        if (val !== oldVal && !this.initEdit) {
          this.schoolModel.district_id.value = null
        }
      } else {
        this.schoolModel.district_id.value = null
      }
    },
    'userModel.district_id.value': async function (val, oldVal) {
      if (val) {
        this.schoolModel.village_id.options = await this.getVillages(val)
        this.totalPromiseAreaCount++;
        if (val !== oldVal && !this.initEdit) {
          this.schoolModel.village_id.value = null
        }
      } else {
        this.schoolModel.village_id.value = null
      }
    },
    'userModel.work_area_city_id.value': async function (val, oldVal) {
      if (val) {
        this.schoolModel.work_area_district_id.options = await this.getDistricts(val)
        this.schoolModel.dapil_id.options = await this.getDapil(val)
        this.totalPromiseAreaCount++;
        if (val !== oldVal && !this.initEdit) {
          this.schoolModel.work_area_district_id.value = null
          this.schoolModel.dapil_id.value = null
        }
      } else {
        this.schoolModel.work_area_district_id.value = null
        this.schoolModel.dapil_id.value = null
      }
    },
    'userModel.work_area_district_id.value': async function (val, oldVal) {
      if (val) {
        if (this.schoolModel.role.value === 'petugas-tps') {
          this.schoolModel.work_area_village_id.options = await this.getVillages(val)
        }
        this.totalPromiseAreaCount++;
        if (val !== oldVal && !this.initEdit) {
          this.schoolModel.work_area_village_id.value = null
        }
      } else {
        this.schoolModel.work_area_village_id.value = null
      }
      // this.setHideModels(this.schoolModel.role.value)
    },
    'totalPromiseAreaCount': async function (val) {
      if (val >= 4) {
        this.initEdit = false;
      }
    },
  },
  computed: {
    mode: function () {
      return this.$route.params.id !== undefined ? 'update' : 'create'
    }
  },
  data () {
    return {
      totalPromiseAreaCount: 0,
      initEdit: false,
      isLoading: false,
      userModel: userModel.init(),
      schoolModel: schoolModel.init(),
    }
  },
  mounted () {
    if (this.mode === 'update') {
      this.schoolModel.password.rules = null
      this.getDetail()
    }
    this.getCities()
  },
  methods: {
    setHideModels (val) {
      if (val === 'petugas-tps') {
        this.schoolModel.work_area_village_id.rules = 'required'
        this.schoolModel.tps.rules = 'required'
        if (document.querySelector('#wrapper-input-work_area_village_id')) {
          document.querySelector('#wrapper-input-work_area_village_id').style.display = "block";
        }
        if (document.querySelector('#wrapper-input-tps')) {
          document.querySelector('#wrapper-input-tps').style.display = "block";
        }
      } else {
        this.schoolModel.work_area_village_id.rules = null;
        this.schoolModel.tps.rules = null;
        if (document.querySelector('#wrapper-input-work_area_village_id')) {
          document.querySelector('#wrapper-input-work_area_village_id').style.display = "none";
        }
        if (document.querySelector('#wrapper-input-tps')) {
          document.querySelector('#wrapper-input-tps').style.display = "none";
        }
      }
    },
    filterModel (search) {
      const filtered = Object.entries(this.schoolModel).filter(mdl => {
        return search.includes(mdl[0])
      });
      let result = {}
      filtered.forEach(element => {
        result[element[0]] = element[1];
      });
      return result;
    },
    getOptions (key) {
      return typeof this.schoolModel[key].options !== 'undefined' ? objectToOptions(this.schoolModel[key].options) : null
    },
    getClassicOptions (key) {
      return typeof this.schoolModel[key].options !== 'undefined' ? classicObjectToOptions(this.schoolModel[key].options) : null
    },
    getDetail () {
      this.initEdit = true
      this.isLoading = true
      userModel.find(this.$route.params.id, {
        detail: 1
      }).then(resp => {
        this.isLoading = false
        let response = {}
        // response = resp
        Object.keys(resp.user_detail).forEach(key => {
          if (!['user_id', 'village', 'city', 'district', 'province'].includes(key)) {
            response[key] = resp.user_detail[key]
          }
        });
        Object.keys(resp.user_work_area).forEach(key => {
          if (!['user_id', 'village', 'city', 'district', 'province'].includes(key)) {
            response[key] = resp.user_work_area[key]
          }
        });
        Object.keys(resp).forEach(key => {
          if (!['user_detail', 'user_work_area'].includes(key)) {
            response[key] = resp[key]
          }
        });
        response['phone_number'] = response['phone_number'].replace('+62', '0');
        setModelValue(this.schoolModel, response)
        Object.keys(this.schoolModel).forEach(key => {
          // if (key === 'role') {
          //   this.$refs[key][0].setValue(resp.roles[0].name)
          // } else {
          //   this.$refs[key][0].setValue(this.schoolModel[key].value)
          // }
          if (typeof this.$refs[key] !== 'undefined') {
            this.$refs[key][0].setValue(this.schoolModel[key].value)
          }
          // setTimeout(() => {
          //   this.initEdit = false
          // }, 500)
        })
      }).catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.error(error)
        }
        // this.initEdit = false
        this.isLoading = false
      })
    },
    resetForm () {
      this.$nextTick(() => {
        // clearModelValue(this.schoolModel)
        Object.keys(this.schoolModel).forEach(key => {
          this.$refs[key][0].setValue(null)
        })
        this.$refs.form.reset()
      })
    },
    onSubmit () {
      this.$refs.form.validate().then(success => {
        if (!success || this.isLoading) {
          scrollToError(this.$refs.form)
          return false
        }
        saveProcess(this.schoolModel, this.mode === 'update').then(model => {
          this.isLoading = true
          if (this.mode === 'update') {
            userModel.update(this.$route.params.id, model).then(() => {
              this.isLoading = false
              this.$store.dispatch('notification/success', 'Data user berhasil diubah.')
              this.$router.push('/users/' + this.$route.params.id)
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          } else {
            userModel.create(model).then(resp => {
              this.isLoading = false
              // this.resetForm()
              this.$store.dispatch('notification/success', 'Data user berhasil disimpan.')
              this.$router.push('/users/' + resp.id)
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        }).catch(() => {})
      })
    }
  }
}
</script>